<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="$emit('input')" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ $t('fichaPDF')}}</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12">
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-checkbox
                    v-model="adjuntarFotosApertura" id="adjuntarFotosApertura"
                    :label="$t('adjuntarFotosApertura')"
                    color="primary"
                  />
                  </v-flex>
                </v-layout>
                <v-layout wrap justify-center>
                  <v-flex xs12 sm12 md12 lg12 pl-1 pr-1>
                  <v-checkbox
                    v-model="adjuntarFotosCierre" id="adjuntarFotosCierre"
                    :label="$t('adjuntarFotosCierre')"
                    color="primary"
                  />
                  </v-flex>
                </v-layout>
              </v-col>

            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click.native="$emit('input')">{{$t('cancelar')}}</v-btn>
          <v-btn color="primary" @click.native="descargarFichaPDF()">{{$t('descargar')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  props: {
    value: Boolean,
    incidenceIds: Array,
    tipoDeFicha: String
  },
  data () {
    return {
      parteSeleccionado: '',
      observaciones: '',
      adjuntarFotosApertura: false,
      adjuntarFotosCierre: false,
      rules: {
        required: value => !!value || this.$t('campoObligatorio')
      }
    }
  },
  mounted () {
    this.getTiposParte()
    this.obtenerConfiguracion()
  },
  computed: {
    partes () {
      if (this.$store.state.incidencias.tiposParte) {
        return this.$store.state.incidencias.tiposParte
      }
      return []
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      obtenerConfiguracion: 'configuracion/obtenerConfiguracion',
      realizarEnvioParte: 'incidencias/realizarEnvioParte',
      getTiposParte: 'incidencias/getTiposParte',
      obtenerPDF: 'incidencias/obtenerPDF'
    }),
    descargarFichaPDF () {
      var loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false
      })
      var ids = []
      if (this.tipoDeFicha === 'C') {
        // si son cerradas, no puede haber incidencias que no esten cerradas
        var noCerradas = this.incidenceIds.find(incidencia => incidencia.statusCode !== '50')
        // si hay incidencias no cerradas no sacamos el informe y mostramos error
        if (noCerradas !== undefined) {
          this.addAlert({texto: this.$t('soloIncidenciasCerradas'), color: 'error'})
          loader.hide()
          this.$emit('input')
          return
        }
      }

      this.incidenceIds.map(e => {
        // dependiendo del tipo de ficha hay que enviar una cosa u otra
        if (this.tipoDeFicha === 'I' || this.tipoDeFicha === 'C') ids.push(e.id)
        if (this.tipoDeFicha === 'V') ids.push(e.visitaId)
      })

      let maxIncisPDF = this.$store.state.configuracion.configuracion.maxIncidenciasFicha

      this.obtenerPDF({
        tipo: this.tipoDeFicha,
        adjuntarFotos: this.adjuntarFotosApertura,
        adjuntarFotosCierre: this.adjuntarFotosCierre,
        ids: ids,
        maxIncisPDF: maxIncisPDF
      }).then(response => {
        var resultado = response.data
        
        if (resultado.result === 'OK' && resultado.data) {
          var nombre = resultado.data.name
          var binario = atob(resultado.data.file_base64)
          var array = []
          for (var i = 0; i < binario.length; i++) {
            array.push(binario.charCodeAt(i))
          }
          var blob = new Blob([new Uint8Array(array)], { type: 'application/pdf' })
          if (window.navigator.msSaveBlob) {
            window.navigator.msSaveOrOpenBlob(blob, nombre)
          } else {
            var a = window.document.createElement('a')
            a.href = window.URL.createObjectURL(blob, { type: 'application/pdf' })
            a.download = nombre
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        } else if ( resultado.message ) {
          this.addAlert({texto: resultado.message, color: 'error'}) 
        } else {
          this.addAlert({texto: this.$t('resultadosNoEncontrados'), color: 'error'})
        }
        loader.hide()
        this.$emit('input')
      })
        .catch((error) => {
          if (!error.code || error.code !== 1) {
            this.waitingForLoad = false
            this.addAlert({texto: error.message, color: 'error'})
          }
          loader.hide()
          this.$emit('input')
        })
    },
    getConfiguracion () {
      return this.$store.state.configuracion.configuracion
    },
    async enviarParteAsync (payload) {
      try {
        var loader = this.$loading.show({
          // Optional parameters
          container: this.fullPage ? null : this.$refs.formContainer,
          canCancel: false
        })
        await Promise.all([this.realizarEnvioParte(payload)])

        loader.hide()
        this.addAlert({ texto: this.$t('envioRealizadoCorrectamente'), color: 'success' })
        this.$emit('input')
      } catch (error) {
        if (!error.code || error.code !== 1) {
          this.addAlert({ texto: error.message, color: 'error' })
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
